import Button from '../../../components/base/Button';

interface FinalCallSectionProps {
  onOpenModal?: () => void;
}

export default function FinalCallSection({ onOpenModal }: FinalCallSectionProps) {
  const handleCTAClick = () => {
    if (onOpenModal) {
      onOpenModal();
    }
  };

  return (
    <section className="py-16 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://vox2you.com.br/wp-content/uploads/2023/08/Snapinsta.app_353422053_275404594986915_5565578790819091741_n_1080-e1692378836490-768x608.jpg')] bg-cover bg-center opacity-5"></div>
      
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight">
            Você pode continuar <span className="text-gray-400">evitando falar…</span>
          </h2>
          <p className="text-2xl md:text-3xl font-bold text-[#F19E1A] mb-6">
            ou dar o primeiro passo para se tornar uma pessoa mais confiante ao se comunicar.
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div className="text-center">
              <i className="ri-close-circle-line text-red-400 text-4xl mb-3 inline-block"></i>
              <p className="text-lg font-semibold mb-2">Continuar travando</p>
              <p className="text-gray-300">Perder oportunidades por falta de confiança</p>
            </div>
            <div className="text-center">
              <i className="ri-check-circle-line text-green-400 text-4xl mb-3 inline-block"></i>
              <p className="text-lg font-semibold mb-2">Transformar sua comunicação</p>
              <p className="text-gray-300">Desbloquear seu potencial em 4 horas</p>
            </div>
          </div>

          <div className="text-center border-t border-white/20 pt-6">
            <p className="text-xl md:text-2xl font-bold mb-3">
              O VoxDay pode ser o momento que marca essa virada.
            </p>
          </div>
        </div>

        <div className="text-center space-y-6">
          <Button 
            size="lg" 
            onClick={handleCTAClick}
            className="text-lg px-10 py-4 shadow-2xl hover:shadow-[#F19E1A]/50 transform hover:scale-105 transition-all duration-300"
          >
            🚀 Quero Garantir Minha Vaga Agora
          </Button>
          
          <div className="flex flex-col items-center gap-3">
            <div className="flex items-center gap-2 text-sm bg-red-500/20 border border-red-500 rounded-full px-4 py-2">
              <i className="ri-alarm-warning-line text-red-400"></i>
              <span className="font-semibold">Somente 40 vagas disponíveis</span>
            </div>
            <p className="text-gray-400 text-sm">
              Mais de 130 mil alunos já passaram pela Vox2you
            </p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-5 text-center border border-white/10">
            <i className="ri-time-line text-[#F19E1A] text-3xl mb-2 inline-block"></i>
            <p className="font-semibold mb-1">4 horas</p>
            <p className="text-sm text-gray-400">de experiência intensa</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-5 text-center border border-white/10">
            <i className="ri-map-pin-line text-[#F19E1A] text-3xl mb-2 inline-block"></i>
            <p className="font-semibold mb-1">100% Presencial</p>
            <p className="text-sm text-gray-400">em Barreiras - BA</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-5 text-center border border-white/10">
            <i className="ri-trophy-line text-[#F19E1A] text-3xl mb-2 inline-block"></i>
            <p className="font-semibold mb-1">Metodologia Vox2you</p>
            <p className="text-sm text-gray-400">comprovada e eficaz</p>
          </div>
        </div>
      </div>
    </section>
  );
}
